module.exports = __webpack_public_path__ + "static/img/__9049.af4a394.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/__9049.jpg
// module id = m/de
// module chunks = 0